module.exports = __webpack_public_path__ + "static/media/art-machine-5.5436cc6a.png";